<template>
  <section>
    <div class="container">
      <header class="header">
        <slot name="title" />
        <slot name="search">
          <InputSearch
            v-if="withSearch"
            v-model="searchData"
            :is-loading="isLoading"
            :min-length="minLength"
            :placeholder-text="placeholderText"
          />
        </slot>
      </header>
      <slot name="subtitle" />
    </div>
    <slot name="results">
      <h2 class="title-strat">Aucun contenu</h2>
    </slot>
  </section>
</template>

<script setup lang="ts">
import type { SearchResultsProps } from '~/types'
import { InputSearchPropsDefaults } from '~/types'

withDefaults(defineProps<SearchResultsProps>(), {
  withSearch: true,
  ...InputSearchPropsDefaults,
})

const emit = defineEmits(['searchUpdate'])

const searchData = ref('')

watch(
  () => searchData.value,
  (val) => {
    emit('searchUpdate', val)
  },
)
</script>

<style lang="scss" scoped>
.container {
  margin: 8rem auto 0;
  padding: 0;

  @media (min-width: 700px) {
    max-width: 200rem;
    padding: 0 8rem;
  }
}

.header {
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
  padding: 0 2.5rem;

  @media (min-width: 700px) {
    padding: 0;
  }

  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5rem;
  }
}

:deep(.title-strat) {
  margin-bottom: 1.5rem;

  @media (min-width: 992px) {
    margin-bottom: 0;
  }
}
</style>
